import { Divider, Flex, PageWrapper, Spacing } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { Fragment, memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const Loading = memo(() => {
    return (
        <PageWrapper>
            <PageWrapper.Toolbar>
                <Skeleton height={28} />

                <Spacing height={12} />

                <Flex spacing='8' alignItems='center'>
                    <Skeleton width={124} height={28} />

                    <Skeleton width={254} height={28} />

                    <Skeleton borderRadius='50%' width={24} height={24} />
                </Flex>
            </PageWrapper.Toolbar>

            <PageWrapper.Content>
                <Flex wrap={false} alignItems='center'>
                    <Flex width={40} justifyContent='center'>
                        <Skeleton width={16} height={16} />
                    </Flex>

                    <Flex width={100} block>
                        <Skeleton width={50} height={16} />
                    </Flex>

                    <Flex width={200} block>
                        <Skeleton width={100} height={16} />
                    </Flex>

                    <Flex width={50} block>
                        <Skeleton width={40} height={16} />
                    </Flex>

                    <Flex width={50} block>
                        <Skeleton width={50} height={16} />
                    </Flex>

                    <Flex width={80} block>
                        <Skeleton width={50} height={16} />
                    </Flex>

                    <Flex width={120} block>
                        <Skeleton width={90} height={16} />
                    </Flex>
                </Flex>

                <Spacing height={12} />

                {range(5).map((index) => (
                    <Fragment key={index}>
                        <Flex wrap={false} alignItems='center'>
                            <Skeleton borderRadius='50%' width={40} height={40} />

                            <Skeleton width={100} height={20} />

                            <Skeleton width={200} height={20} />

                            <Skeleton width={50} height={20} />

                            <Skeleton width={50} height={20} />

                            <Skeleton width={80} height={20} />

                            <Skeleton width={120} height={20} />

                            <Flex justifyContent='end' alignItems='center' block>
                                <Skeleton width={24} height={10} />
                            </Flex>
                        </Flex>

                        <Divider spacing='4 0' />
                    </Fragment>
                ))}
            </PageWrapper.Content>
        </PageWrapper>
    );
});

export default Loading;
